import React from 'react'
import { Text } from '../../components/DesignSystem'

export default function TermsOfUseContent() {
	return (
		<Text level="small">
			{`Yes, I have read and agree with the`}{' '}
			<Text
				level="small"
				style={{ color: 'mediumblue' }}
				onPress={() => {
					window.open('/terms-of-use', '_blank')
				}}
			>
				Terms of Use
			</Text>
			{` and consent to my personal information being used and shared with service providers for the purposes set out in the Terms of Use.`}
		</Text>
	)
}
